import { useEffect } from 'react';
import { isAndroid, isIOS, isMacOs, isWindows } from 'react-device-detect';

function Device() {
  useEffect(() => {
    if (isAndroid) {
      window.location.href = `https://apps.apple.com/us/app/aife-ai-for-everyone/id6739445777`;
    }
    if (isIOS) {
      window.location.href = `https://apps.apple.com/us/app/aife-ai-for-everyone/id6739445777`;
    }
    if (isMacOs) {
      window.open(
        `https://apps.apple.com/us/app/aife-ai-for-everyone/id6739445777`,
        '_blank'
      );
    }
    if (isWindows) {
      window.open(
        `https://apps.apple.com/us/app/aife-ai-for-everyone/id6739445777`,
        '_blank'
      );
    }
  }, []);

  return <div></div>;
}

export default Device;
